import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z","key":"svg-0"}]]

/**
 * IconCropPortraitFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItY3JvcC1wb3J0cmFpdCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTYgM2EzIDMgMCAwIDEgMyAzdjEyYTMgMyAwIDAgMSAtMyAzaC04YTMgMyAwIDAgMSAtMyAtM3YtMTJhMyAzIDAgMCAxIDMgLTN6IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/crop-portrait-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCropPortraitFilled = createReactComponent('filled', 'crop-portrait-filled', 'CropPortraitFilled', __iconNode);

export default IconCropPortraitFilled;